var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[[_c(_vm.mapComponent,{tag:"component",attrs:{"zoom":_vm.zoom,"center":_vm.center,"url":_vm.url,"attribution":_vm.attribution,"marker":_vm.computedMarker},on:{"click-on-marker":_vm.clickOnMarker}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }